/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'newspaper': {
    width: 512,
    height: 512,
    viewBox: '0 0 512 512',
    data: '<path pid="0" d="M448 128V64H0v352c0 17.673 14.327 32 32 32h432c26.511 0 48-21.489 48-48V128h-64zm-32 288H32V96h384v320zM64 160h320v32H64zm192 64h128v32H256zm0 64h128v32H256zm0 64h96v32h-96zM64 224h160v160H64z"/>'
  }
})
